import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { ChevronRight } from "lucide-react";

export const FinalCta = () => {
  const reduce = useReducedMotion();
  return (
    <section data-testid="final-cta-section" className="border-t border-slate-100 bg-white py-24 lg:py-32">
      <div className="mx-auto max-w-4xl px-6 lg:px-8">
        <motion.div
          initial={reduce ? false : { opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="relative overflow-hidden rounded-3xl border border-slate-200 bg-white p-10 text-center shadow-floating sm:p-16"
        >
          <div className="pointer-events-none absolute -left-16 -top-16 h-56 w-56 rounded-full bg-demax-soft blur-3xl" />
          <div className="pointer-events-none absolute -bottom-16 -right-16 h-56 w-56 rounded-full bg-demax-soft blur-3xl" />

          <div className="relative">
            <h2 className="mx-auto max-w-2xl font-display text-3xl font-extrabold leading-tight tracking-tight text-ink md:text-5xl">
              Buy full containers. Manage everything in one Workspace.
            </h2>
            <p className="mx-auto mt-5 max-w-xl text-base text-slateink md:text-lg">
              Purchase directly from verified Turkish manufacturers while managing every stage of
              your import operation through the DeMaxtore Workspace.
            </p>

            <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <button
                data-testid="final-primary-cta"
                className="group inline-flex w-full items-center justify-center gap-2 rounded-full bg-demax px-7 py-3.5 text-sm font-semibold text-white shadow-btn transition-all duration-200 hover:-translate-y-0.5 hover:bg-demax-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-demax focus-visible:ring-offset-2 sm:w-auto"
              >
                Create Your FullContainer™
                <ChevronRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
              </button>
              <button
                data-testid="final-secondary-cta"
                className="inline-flex w-full items-center justify-center rounded-full border border-slate-200 bg-white px-7 py-3.5 text-sm font-semibold text-ink transition-all duration-200 hover:bg-slate-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-demax focus-visible:ring-offset-2 sm:w-auto"
              >
                Create Your Free Workspace
              </button>
            </div>

            <p className="mt-6 text-xs font-medium text-slate-400">
              Factory Direct Purchasing · No Product Markups · Verified Turkish Manufacturers
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
